import { UtilityServices } from './../../../../Services/utility.services';
import { Component, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AppsettingService } from '../../../../Services/appsetting.service';
import { SecureStorageService } from '../../../../Services/secure-storage.service';
import { applicationPaths, localStorageKeys } from '../../../../Models/configurations';
import { FeatureCode } from 'projects/Autofacets-Core/src/app/utils/enums';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';

@Component({
  selector: 'app-first-step',
  templateUrl: './first-step.component.html',
  styleUrls: ['./first-step.component.css']
})
export class FirstStepComponent implements OnInit {
  closeResult: string;
  urlName: string;
  embadedVidoeUrl: any;
  ScreenDetails:any;
  IsPrivacyConsent:boolean;
  data:any[];
  dailymotionUrl = '../../../../../assets/vidoes/vidoe.mp4';
  distanceInKm:number;
  OnlineCheckinLink : any  = ''
  isOnlineCheckinLink:boolean = false
  isMapDirection:boolean = true
  mapDirectionLink:string = ''
  private modalRef: NgbModalRef;

  constructor(
    private readonly modalService: NgbModal,
    private readonly utilityService: UtilityServices,
    private readonly appsettingService: AppsettingService,
    private readonly secureStorageService: SecureStorageService,
    private readonly currentLng:CurrentLanguage,
    private readonly sanitizer: DomSanitizer
  ) {
    this.urlName = '/' + applicationPaths.second;
    if (this.secureStorageService.getKeyData(localStorageKeys.stepStatus) === undefined) {

      this.data=this.appsettingService.fetchSiteElements();
      this.secureStorageService.setKeyData(localStorageKeys.stepStatus, this.data);
    }

  }

  public startCheckIn() {
    this.utilityService.navigateToNext(this.urlName);
  }

  public callDealer() {
    this.utilityService.navigateToNext('/' + applicationPaths.calldealer);
  }

  public openVirtualTour(content) {
    this.modalRef = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit(): void {
    const checkInData = this.secureStorageService.getKeyData(localStorageKeys.checkingModule);
    this.distanceInKm = checkInData.dealerDetail.distance;
    this.IsPrivacyConsent = false;

    if(!this.IsPrivacyConsent){
    this.secureStorageService.setKeyData(localStorageKeys.privacyConsent, false);
    }

    this.currentLng.featureList.subscribe((response) => {
      if(response?.length > 0){
        this.isOnlineCheckinLink = response.find(x=>x.featureCode === FeatureCode.CheckInVideoLink)?.isActive
        if(this.isOnlineCheckinLink){
          this.OnlineCheckinLink = response.find(x=>x.featureCode === FeatureCode.CheckInVideoLink)?.serviceUrl1;
        }
        this.isMapDirection = response.find(x=>x.featureCode === FeatureCode.MapDirection)?.isActive
        if(this.isMapDirection){
          const plateform = Utility.detectDevicePlatform();
          let link = response.find(x=>x.featureCode === FeatureCode.MapDirection)?.serviceUrl1;
          if (plateform == 'ios') {
            link = response.find(x=>x.featureCode === FeatureCode.MapDirection)?.serviceUrl2;
          }
          this.mapDirectionLink = link + Utility.getDirectionAddress(checkInData.dealerDetail);
        }
        else{
          this.isMapDirection = false;
        }
      }
    })
  }
  transform() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      this.OnlineCheckinLink
    );
  }
  openMapDirection() {
    const address = this.mapDirectionLink.split('daddr=')[1];
    const encodedAddr = encodeURIComponent(address);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const origin = `${position.coords.latitude},${position.coords.longitude}`;
          this.launchDirections(encodedAddr, encodeURIComponent(origin));
        },
        () => {
          this.launchDirections(encodedAddr, '');
        }
      );
    } else {
      this.launchDirections(encodedAddr, '');
    }
  }

  private launchDirections(encodedAddr: string, encodedOrigin: string) {
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      window.location.href = `comgooglemaps://?saddr=${encodedOrigin}&daddr=${encodedAddr}`;
      setTimeout(() => !document.hidden && (window.location.href = `maps://?saddr=${encodedOrigin}&daddr=${encodedAddr}`), 500);
      setTimeout(() => !document.hidden && window.open(`https://www.google.com/maps/dir/?api=1&origin=${encodedOrigin}&destination=${encodedAddr}`, '_blank'), 1000);
    } else {
      window.open(`https://www.google.com/maps/dir/?api=1&origin=${encodedOrigin}&destination=${encodedAddr}`, '_blank');
    }
  }
}
